import { getCurrentYear } from '~/utils/date';
import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';
import { z } from 'zod';

export const querySchema = z
  .object({
    search: z.string().default(''),
    year: z.string().default(String(getCurrentYear())).transform(x => parseInt(x)),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
